import React, { useEffect, useState } from 'react';

const InRoomDiningCustomisationViewDetail = ({ customisation }) => {
  useEffect(() => {}, [customisation]);

  return (
    <div className='row mx-4 mt-4'>
      {
        <>
          <div className='col-md-6 mt-4'>
            <div className='details-label'>Customisation Name</div>
            <div className='details-value preview-breaks'>{customisation.name}</div>
          </div>
          <div className='col-md-6 mt-4'>
            <div className='details-label text-center'>Status</div>
            <div
              className={`${
                customisation.status ? 'pill-active' : 'pill-inactive'
              } col-md-3 pill-text pill container`}
            >
              <span>{customisation.status ? 'Active' : 'Inactive'}</span>
            </div>
          </div>
          <div className='col-md-12 mt-4'>
            <div className='details-label'>Customisation Code</div>
            <div className='details-value'>{customisation.code}</div>
          </div>
          {customisation?.customAttributes &&
            customisation?.customAttributes?.length > 0 &&
            customisation?.customAttributes?.map((item, index) => (
              <div key={index} className='col-md-6 mt-4'>
                <div className='details-label'>{item.key}</div>
                <div className='details-value'>{item.value}</div>
              </div>
            ))}
        </>
      }
    </div>
  );
};

export default InRoomDiningCustomisationViewDetail;
